export enum TypeGroupMaterial {
  None,
  Other,
  Plate,
  Butt,
  FastenersAndAccessories,
  Linear = 254,
}

export class CuttingMatBaseGroup {
  id: number;
  name: string;
  parentId: number;
  type: TypeGroupMaterial;
  children: CuttingMatBaseGroup[];

  constructor(group?: CuttingMatBaseGroup | any) {
    group = group || {};
    this.id = group.id || 0;
    this.name = group.name || '';
    this.type = group.type || TypeGroupMaterial.Plate;
    this.children = group.children || [];
    this.parentId = group.parentId || 0;
  }
}
